/*
 * @Description: 未支付-全部未支付
 * @Date: 2020-12-12 17:43:20
 */

import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { listPayOrderDetail, unPayStatisticsAmount } from '@/api/ajax';

let example = new TableRenderClass({ fields, search });

// 页面入口
const part = example.createPart({
  name: '订单详情',
  search: [
    'orderNo',
    'projectName',
    'createDate',
    'payStatus',
    'fullName',
    'phone',
    'supplierId'
  ],
  list: listPayOrderDetail,
  requestNow: true,
  fields: [
    'index',
    'orderNo',
    'fullName',
    'userPhone',
    'bankNo',
    'collectMoneyType',
    'projectName',
    'createDate',
    'supplierName',
    'finishSum',
    'taskPrice',
    'finishSumTaskPrice',
    'commission',
    'totalPrice',
    'payStatus03',
    'finishPayDt'
  ]
});

// individualAjax 为独立注册字段，用于获取总价接口
export default {
  name: '订单详情',
  childMenu: [{ ...part, individualAjax: unPayStatisticsAmount }]
};
